module.exports = __webpack_public_path__ + "static/media/mastercard.52882103.svg";